
import { mapGetters } from 'vuex';
import generateDefImageIcon from '~/mixins/generate-def-image-icon';

export default {
    mixins: [generateDefImageIcon],
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings'
        })
    }
};
